// Third party imports
import { createSlice } from "@reduxjs/toolkit";

export const filtersManagerSlice = createSlice({
  name: "filtersManager",
  initialState: {
    filters: {},
    modalFilters: {},
  },
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },
    clearFilters(state) {
      state.filters = {};
    },
    setModalFilters(state, action) {
      state.modalFilters = action.payload;
    },
    clearModalFilters(state) {
      state.modalFilters = {};
    },
  },
});
export const { setFilters, clearFilters, setModalFilters, clearModalFilters } =
  filtersManagerSlice.actions;
export default filtersManagerSlice.reducer;
